"use client";

import { motion, useReducedMotion } from "motion/react";

/**
 * BeBot, la mascotte, en image. Remplace l'ancienne animation Lottie (l'ancien
 * dessin, sans bras ni jambes) partout où elle servait d'attente ou de
 * célébration. Les images vivent dans public/images/bebot/coach/, au format
 * carré, aux violets de la charte.
 *
 * Un léger flottement lui garde un peu de vie : sur un écran de chargement, une
 * image figée fait croire à une panne. Il se coupe si le système demande moins
 * d'animations, ou avec `still`.
 *
 * @param {object} props
 * @param {"happy"|"sad"|"surprised"|"malicious"|"wave"} [props.mood]
 * @param {string} [props.width]      Largeur CSS (« 200px », « 100% »).
 * @param {string} [props.className]
 * @param {boolean} [props.still]     Sans flottement.
 */
export default function BebotMascot({ mood = "happy", width = "200px", className = "", still = false }) {
    const reduceMotion = useReducedMotion();
    const floats = !still && !reduceMotion;

    return (
        <motion.img
            src={`/images/bebot/coach/${mood}.webp`}
            alt="BeBot"
            width={480}
            height={480}
            style={{ width, height: "auto" }}
            className={`block max-w-full ${className}`}
            animate={floats ? { y: [0, -5, 0] } : undefined}
            transition={floats ? { duration: 2.6, ease: "easeInOut", repeat: Infinity } : undefined}
        />
    );
}
